<template>
  <layout-main-inner title="内容详情">
    <div slot="action">
      <el-button
        type="primary"
        @click="update">编辑</el-button>
    </div>
    <layout-card-wrap hasHeaderSlot>
      <template slot="title">基本信息</template>
      <el-form
        label-position="top"
        label-width="110px">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="内容标题：">{{ info.title }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="内容类型：">
              <span v-if="info.contentType === 0">多图</span>
              <span v-if="info.contentType === 1">公众号链接</span>
              <!-- <span v-if="info.contentType === 3">商品链接</span> -->
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="内容说明：">{{ info.name }}</el-form-item>
          </el-col>
        </el-row>
        <el-row
          v-if="info.contentType===0">
          <el-col :span="12">
            <el-form-item label="图片详情：">
              <desc-images v-model="info.content"></desc-images>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row
          v-if="info.contentType===1">
          <el-col :span="8">
            <el-form-item label="公众号文章链接：">
              {{ info.content }}
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row
          v-if="info.contentType===3"
          type="flex"
          justify="center">
          <el-col :span="12">
            <el-form-item label="商品信息：">
              {{ goodsInfo.goodsName || goodsInfo.goodsFullname }}
            </el-form-item>
          </el-col>
        </el-row> -->
      </el-form>
    </layout-card-wrap>
  </layout-main-inner>
</template>
<script>
import DescImages from '@/components/public/desc-images.vue'
export default {
  name: 'WxappMessageDetail',
  components: {
    DescImages
  },
  props: {},
  data() {
    return {
      loading: false,
      info: {}
    }
  },
  computed: {
    goodsInfo() {
      return this.info.contentType === 3 ? JSON.parse(this.info.content || '{}') : {}
    }
  },
  mounted() {
    this.getmessage()
  },
  methods: {
    update() {
      this.$router.push(`/wxapp-message-edit?msgId=${this.info.msgId}&vendorId=${this.info.vendorId}`)
    },
    getmessage() {
      this.loading = true
      this.$store.dispatch('portal/getmessage', {
        payload: {
          vendorId: this.$route.query.vendorId,
          msgId: this.$route.query.msgId
        },
        success: res => {
          this.loading = false
          this.info = {
            ...res.data,
            content: res.data.contentType === 0 ? res.data.content.split(',').map(item => ({
              url: item,
              name: item,
              mediaType: /(\.mp4|\.webm|\.avi)$/g.test(item) ? 2 : 1
            })) : res.data.content
          }
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
